import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinemumbaitopunecabbooking() {



  const cardData = {


  keyword: "Online Mumbai to Pune Cab Booking",

  headingDescription: "Trustline Cab provides easy and reliable online Mumbai to Pune cab booking services with safe, comfortable, and affordable taxi options for business trips, airport transfers, corporate travel, family journeys, and outstation rides. With a simple booking process, professional chauffeurs, and well-maintained vehicles, we ensure a smooth travel experience from Mumbai to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury cars suitable for individuals, families, and groups. With transparent fares, doorstep pickup, flexible travel timings, real-time booking assistance, and 24/7 customer support, Trustline Travels makes Mumbai to Pune taxi booking convenient, secure, and hassle-free.",

  topPlaces: [
    {
      title: "Pune Hinjewadi IT Park",
      description: "Hinjewadi IT Park is Pune's leading technology and corporate destination, housing multinational companies, software firms, startups, and business centers. It is a major location for professionals traveling from Mumbai for meetings, projects, and corporate requirements."
    },
    {
      title: "Pune Airport",
      description: "Pune Airport connects the city with major destinations across India and is an important hub for business travelers, tourists, and corporate passengers. Reliable cab services are preferred for convenient airport transfers from Mumbai."
    },
    {
      title: "EON IT Park Kharadi",
      description: "EON IT Park in Kharadi is one of Pune's largest IT and business campuses, featuring global technology companies, corporate offices, and modern infrastructure. It attracts thousands of professionals and business visitors every day."
    },
    {
      title: "Magarpatta City",
      description: "Magarpatta City is a well-planned business and residential township known for IT parks, corporate offices, shopping areas, and modern facilities. It is a popular destination for professionals and corporate travelers."
    },
    {
      title: "Pimpri Chinchwad Industrial Area",
      description: "Pimpri Chinchwad is a major industrial and commercial region famous for automobile companies, manufacturing units, engineering businesses, and corporate establishments. It is an important destination for industrial and business travel."
    },
    {
      title: "Bavdhan",
      description: "Bavdhan is a growing residential and commercial locality in Pune, offering IT offices, educational institutions, premium housing projects, and excellent connectivity to Mumbai-Pune Expressway. It is preferred by families and professionals."
    },
    {
      title: "Koregaon Park",
      description: "Koregaon Park is one of Pune's premium lifestyle destinations, known for upscale restaurants, cafés, hotels, shopping areas, and vibrant nightlife. It attracts tourists, business visitors, and professionals."
    },
    {
      title: "Shivajinagar",
      description: "Shivajinagar is a central Pune locality featuring commercial offices, educational institutions, government establishments, shopping markets, and excellent transport connectivity. It is an important destination for daily commuters and business travelers."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a beautiful hill station located between Mumbai and Pune, famous for waterfalls, viewpoints, green valleys, and pleasant weather. It is a popular stopover and weekend getaway destination during Mumbai-Pune journeys."
    },
    {
      title: "Khandala",
      description: "Khandala is a scenic hill destination near Lonavala known for misty mountains, valleys, viewpoints, and peaceful surroundings. It is a favorite attraction for travelers looking for a refreshing break between Mumbai and Pune."
    }
  ],






"services": [
  {
    "name": "Navi Mumbai to Pune Cab",
    "description": "Book Navi Mumbai to Pune Cab for comfortable intercity travel with professional chauffeurs, clean AC vehicles, transparent pricing, doorstep pickup, and reliable service. Choose Sedan, Ertiga, Innova Crysta, SUV, and premium cars for business trips, family travel, airport transfers, and hassle-free journeys."
  },
  {
    "name": "Thane to Pune Cab",
    "description": "Choose Thane to Pune Cab for safe and affordable travel with experienced drivers, comfortable seating, well-maintained vehicles, fixed fares, and smooth highway connectivity. Ideal for corporate travel, family trips, and personal transportation."
  },
  {
    "name": "Panvel to Pune Cab",
    "description": "Book Panvel to Pune Cab with professional chauffeurs, AC vehicles, flexible pickup options, transparent pricing, and reliable long-distance travel service for business and family journeys."
  },
  {
    "name": "Vashi to Pune Cab",
    "description": "Reserve Vashi to Pune Cab for comfortable travel with premium vehicles, experienced drivers, affordable fares, and convenient doorstep pickup service between Vashi and Pune."
  },
  {
    "name": "Kharghar to Pune Cab",
    "description": "Choose Kharghar to Pune Cab for smooth intercity transportation with clean AC cars, professional drivers, fixed pricing, and comfortable travel experience."
  },
  {
    "name": "Nerul to Pune Cab",
    "description": "Book Nerul to Pune Cab with reliable chauffeurs, spacious vehicles, transparent fares, and safe highway travel for families, professionals, and tourists."
  },
  {
    "name": "Belapur to Pune Cab",
    "description": "Hire Belapur to Pune Cab for convenient travel with premium vehicles, experienced drivers, affordable pricing, and dependable door-to-door cab service."
  },
  {
    "name": "Airoli to Pune Cab",
    "description": "Choose Airoli to Pune Cab with comfortable AC vehicles, professional chauffeurs, flexible schedules, and reliable transportation for one-way and round trips."
  },
  {
    "name": "Andheri to Pune Cab",
    "description": "Book Andheri to Pune Cab for safe and comfortable intercity travel with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicle options."
  },
  {
    "name": "Borivali to Pune Cab",
    "description": "Reserve Borivali to Pune Cab for affordable travel with clean vehicles, experienced drivers, transparent pricing, and smooth highway journeys."
  },
  {
    "name": "Dadar to Pune Cab",
    "description": "Book Dadar to Pune Cab with professional chauffeur service, comfortable AC cars, doorstep pickup, and reliable transportation."
  },
  {
    "name": "Bandra to Pune Cab",
    "description": "Choose Bandra to Pune Cab for premium travel with experienced drivers, luxury vehicles, flexible booking, and comfortable long-distance journeys."
  },
  {
    "name": "Powai to Pune Cab",
    "description": "Book Powai to Pune Cab with affordable fares, professional chauffeurs, clean AC vehicles, and dependable intercity transportation."
  },
  {
    "name": "BKC to Pune Cab",
    "description": "Choose BKC to Pune Cab for corporate travel with premium vehicles, punctual pickup, experienced drivers, and comfortable business transportation."
  },
  {
    "name": "Goregaon to Pune Cab",
    "description": "Reserve Goregaon to Pune Cab for safe travel with chauffeur-driven vehicles, transparent pricing, and reliable cab service."
  },
  {
    "name": "Kandivali to Pune Cab",
    "description": "Book Kandivali to Pune Cab with comfortable seating, AC vehicles, experienced drivers, and affordable pricing for smooth travel."
  },
  {
    "name": "Innova Crysta Mumbai to Pune Cab",
    "description": "Travel with Innova Crysta Mumbai to Pune Cab featuring premium interiors, spacious seating, luggage capacity, professional chauffeurs, and comfortable travel for families and groups."
  },
  {
    "name": "Ertiga Mumbai to Pune Cab",
    "description": "Book Ertiga Mumbai to Pune Cab for affordable family travel with 6-seater comfort, AC facilities, experienced drivers, and reliable service."
  },
  {
    "name": "Sedan Mumbai to Pune Cab",
    "description": "Choose Sedan Mumbai to Pune Cab for economical and comfortable travel with clean vehicles, professional drivers, and smooth highway journeys."
  },
  {
    "name": "Kia Carens Mumbai to Pune Cab",
    "description": "Reserve Kia Carens Mumbai to Pune Cab for premium family transportation with spacious seating, comfortable interiors, and professional chauffeur service."
  },
  {
    "name": "SUV Cab Mumbai to Pune",
    "description": "Book SUV Cab Mumbai to Pune for group travel, business trips, and family journeys with spacious vehicles, experienced drivers, and premium comfort."
  },
  {
    "name": "Premium Car Rental Mumbai to Pune",
    "description": "Choose Premium Car Rental Mumbai to Pune with luxury vehicles, chauffeur-driven service, comfortable interiors, and reliable transportation for special and corporate travel."
  },
  {
    "name": "Luxury Cab Mumbai to Pune",
    "description": "Travel with Luxury Cab Mumbai to Pune featuring premium vehicles, professional chauffeurs, personalized service, and comfortable long-distance travel."
  },
  {
    "name": "Best Mumbai to Pune Cab Service",
    "description": "Choose Best Mumbai to Pune Cab Service for reliable travel with affordable fares, premium vehicles, professional drivers, flexible booking, and 24x7 customer support."
  },
  {
    "name": "Mumbai to Pune Cab with Toll Included",
    "description": "Book Mumbai to Pune Cab with Toll Included for transparent pricing without extra toll concerns, comfortable vehicles, experienced drivers, and hassle-free intercity travel."
  },
  {
    "name": "Mumbai to Pune One Way Taxi Service",
    "description": "Choose Mumbai to Pune One Way Taxi Service for direct travel with affordable pricing, professional chauffeurs, and comfortable AC vehicles."
  },
  {
    "name": "Mumbai Airport to Pune Cab Service",
    "description": "Book Mumbai Airport to Pune Cab Service for reliable airport pickup with experienced drivers, luggage assistance, clean vehicles, and timely destination drop."
  },
  {
    "name": "Mumbai to Pune Airport Drop Cab",
    "description": "Reserve Mumbai to Pune Airport Drop Cab for smooth airport transportation with premium vehicles, flexible timing, and dependable chauffeur service."
  },
  {
    "name": "Affordable Mumbai to Pune Cab Booking",
    "description": "Complete Affordable Mumbai to Pune Cab Booking with budget-friendly fares, instant confirmation, multiple vehicle choices, and reliable travel service."
  },
  {
    "name": "Premium Mumbai to Pune Taxi Service",
    "description": "Choose Premium Mumbai to Pune Taxi Service for luxury travel with high-quality vehicles, professional drivers, and comfortable journeys."
  },
  {
    "name": "Reliable Mumbai to Pune Intercity Cab",
    "description": "Book Reliable Mumbai to Pune Intercity Cab with experienced chauffeurs, clean AC vehicles, transparent fares, and safe highway travel."
  },
  {
    "name": "24 Hours Mumbai to Pune Cab Service",
    "description": "Get 24 Hours Mumbai to Pune Cab Service with round-the-clock booking availability, professional drivers, clean vehicles, and dependable transportation."
  },
  {
    "name": "Door to Door Mumbai to Pune Cab",
    "description": "Choose Door to Door Mumbai to Pune Cab for convenient pickup and drop service with comfortable vehicles and professional chauffeur support."
  }
],

"tableData": [
  ["Navi Mumbai to Pune Cab", "Thane to Pune Cab"],
  ["Panvel to Pune Cab", "Vashi to Pune Cab"],
  ["Kharghar to Pune Cab", "Nerul to Pune Cab"],
  ["Belapur to Pune Cab", "Airoli to Pune Cab"],
  ["Andheri to Pune Cab", "Borivali to Pune Cab"],
  ["Dadar to Pune Cab", "Bandra to Pune Cab"],
  ["Powai to Pune Cab", "BKC to Pune Cab"],
  ["Goregaon to Pune Cab", "Kandivali to Pune Cab"],
  ["Innova Crysta Mumbai to Pune Cab", "Ertiga Mumbai to Pune Cab"],
  ["Sedan Mumbai to Pune Cab", "Kia Carens Mumbai to Pune Cab"],
  ["SUV Cab Mumbai to Pune", "Premium Car Rental Mumbai to Pune"],
  ["Luxury Cab Mumbai to Pune", "Best Mumbai to Pune Cab Service"],
  ["Mumbai to Pune Cab with Toll Included", "Mumbai to Pune One Way Taxi Service"],
  ["Mumbai Airport to Pune Cab Service", "Mumbai to Pune Airport Drop Cab"],
  ["Affordable Mumbai to Pune Cab Booking", "Premium Mumbai to Pune Taxi Service"],
  ["Reliable Mumbai to Pune Intercity Cab", "24 Hours Mumbai to Pune Cab Service"],
  ["Door to Door Mumbai to Pune Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Easy Online Mumbai to Pune Cab Booking",
    WhyChoosedescription: "Trustline Travels offers a simple and convenient online cab booking experience for Mumbai to Pune travel with quick confirmation and reliable service."
  },
  {
    WhyChooseheading: "Instant Booking Assistance",
    WhyChoosedescription: "Get fast responses, fare details, and booking support to plan your Mumbai to Pune journey without unnecessary waiting."
  },
  {
    WhyChooseheading: "Verified Professional Drivers",
    WhyChoosedescription: "Our experienced chauffeurs provide safe, punctual, and comfortable rides with excellent knowledge of the Mumbai-Pune route."
  },
  {
    WhyChooseheading: "Comfortable Cars for Every Need",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your travel group and comfort requirements."
  },
  {
    WhyChooseheading: "Transparent Online Cab Fare",
    WhyChoosedescription: "View clear pricing details before booking with no hidden charges, making your online cab reservation simple and trustworthy."
  },
  {
    WhyChooseheading: "Pickup from Anywhere in Mumbai",
    WhyChoosedescription: "Book doorstep pickup from homes, offices, hotels, Mumbai Airport, railway stations, and major locations across Mumbai."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "Select one-way trips, round trips, airport transfers, or customized Mumbai to Pune cab packages according to your plans."
  },
  {
    WhyChooseheading: "24/7 Online Booking Support",
    WhyChoosedescription: "Our support team is available anytime to help with bookings, vehicle selection, and travel-related queries."
  }
]

};

const faqData = [
  {
    question: "How can I book Mumbai to Pune cab online with Trustline Travels?",
    answer: "You can easily book your Mumbai to Pune cab online by sharing pickup details, travel date, passenger information, and preferred vehicle to receive confirmation."
  },
  {
    question: "Does Trustline Cab provide online cab booking facility?",
    answer: "Yes, Trustline Cab provides a convenient online booking option for Mumbai to Pune cabs with quick assistance and confirmation."
  },
  {
    question: "Can I book a one-way Mumbai to Pune cab online?",
    answer: "Yes, online one-way cab booking is available for Mumbai to Pune travel with flexible pickup and drop locations."
  },
  {
    question: "Which cars can be booked online for Mumbai to Pune travel?",
    answer: "You can book Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers online according to your requirements."
  },
  {
    question: "Can I schedule my cab booking in advance?",
    answer: "Yes, advance online booking is available and recommended to ensure your preferred vehicle and travel timing."
  },
  {
    question: "Do you provide Mumbai Airport to Pune online cab booking?",
    answer: "Yes, you can book airport transfer cabs online from Mumbai Airport to Pune with convenient pickup arrangements."
  },
  {
    question: "Is online cab booking available 24 hours?",
    answer: "Yes, Mumbai to Pune online cab booking assistance is available 24/7 for your travel convenience."
  },
  {
    question: "Are online cab fares fixed before booking?",
    answer: "Yes, fare details are shared clearly before confirmation so customers can make informed booking decisions."
  },
  {
    question: "Is online cab booking suitable for corporate travelers?",
    answer: "Yes, our online booking service is suitable for corporate employees, business travelers, families, and individual passengers."
  },
  {
    question: "Why choose Trustline Travels for online Mumbai to Pune cab booking?",
    answer: "Trustline Cab provides reliable vehicles, professional drivers, transparent pricing, and easy online booking support for a smooth travel experience."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Sawant",
    feedback: "The online booking process was quick and convenient. Trustline Travels provided timely updates, a comfortable vehicle, and a smooth Mumbai to Pune journey with excellent service quality.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Priya Nair",
    feedback: "A seamless travel experience from booking confirmation to final drop. The professional coordination, clean cab, and reliable driver service made the entire journey comfortable.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Mumbai to Pune Cab Booking",
  "image": "https://www.trustlinetravels.com/assets/images/online-mumbai-to-pune-cab-booking.webp",
  "description": "Book online Mumbai to Pune cab service with Trustline Travels for safe, comfortable, and reliable intercity travel. Get one-way, round-trip, airport, and outstation taxi services from Mumbai locations to Pune with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8256"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/online-mumbai-to-pune-cab-booking"
  }
};






  return (
    <div>
<Helmet>
  <title>Online Mumbai to Pune Cab Booking | One Way Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book online Mumbai to Pune cab with Trustline Travels. Get reliable one-way, round-trip, airport, and outstation taxi services from Navi Mumbai, Thane, Panvel, Vashi, Andheri, Borivali, Bandra, Powai, and other Mumbai areas to Pune."
  />

  <meta
    name="keywords"
    content="Navi Mumbai to Pune Cab, Thane to Pune Cab, Panvel to Pune Cab, Vashi to Pune Cab, Kharghar to Pune Cab, Nerul to Pune Cab, Belapur to Pune Cab, Airoli to Pune Cab, Andheri to Pune Cab, Borivali to Pune Cab, Dadar to Pune Cab, Bandra to Pune Cab, Powai to Pune Cab, BKC to Pune Cab, Goregaon to Pune Cab, Kandivali to Pune Cab, Online Mumbai to Pune Cab Booking, Mumbai to Pune Cab Service, Mumbai Pune Taxi Booking, Mumbai Pune One Way Cab, Mumbai Pune Airport Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/90.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onlinemumbaitopunecabbooking;